<template>
  <b-container>
    <b-card class="mt-3">
      <p class="font-weight-bold mb-0" v-html="errorMessage"></p>
      <b-button
        v-if="isShowBackBtn"
        pill
        type="reset"
        variant="outline-danger"
        v-on:click="back()"
      >
        {{ backBtnLabel }}
      </b-button>
    </b-card>
  </b-container>
</template>
<script>
export default {
  name: "ErrorPage",
  data() {
    return {
      errorMessage: this.$root.errorMessage,
      isShowBackBtn: false,
      backBtnLabel: "上一頁",
      backBtnUrl: "/",
      backQuery: {},
    };
  },
  created() {
    let page = this.$route.query.page;
    console.info("page:" + JSON.stringify(this.$route.query.page));
    let status = this.$route.query.status;
    console.info("status:" + JSON.stringify(this.$route.query.status));

    if (status !== "SUCCESS" && status !== undefined) {
      // 特別處理 藍新 MPG 交易失敗顯示訊息
      this.$nextTick(() => {
        const { donationNo, message } = this.$route.query;

        // 提取底線前的長版訊息部分
        const displayMessage = message
          ? String(message).split("_")[0] || message
          : "付款失敗，請重新嘗試";

        this.errorMessage = `
          <div style="line-height:1.8; font-size:20px; color:#333;">
            <div><strong>訂單號碼：</strong>${donationNo || ""}</div>
            <div style="margin:8px 0 12px;">
              <strong>刷卡結果：</strong>
              <span style="color:#d93025; font-weight:600;">
                ${displayMessage || "付款失敗，請重新嘗試"}
              </span>
            </div>
            <div style="font-size:15px; color:#555;">
              請關閉此頁面，回到簡訊中的付款連結重新進行付款。<br/>
              若多次嘗試仍無法完成，請聯繫客服人員協助處理。
            </div>
          </div>
         `.trim();
      });
    }

    switch (page) {
      case "CARD":
        let uuid = this.$route.query.uuid;
        this.isShowBackBtn = true;
        this.backBtnLabel = "重新輸入";
        this.backBtnUrl = "/card";
        this.backQuery = { uuid: uuid };
        break;
    }
  },
  methods: {
    back() {
      this.$nextTick(() => {
        this.$router.replace({ path: this.backBtnUrl, query: this.backQuery });
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.left-btn {
  margin-right: 8px;
}
.right-btn {
  margin-left: 8px;
}
.address-input {
  margin-bottom: 3px;
}
</style>
